import chroma from 'chroma-js';
import { memo } from 'react';
import {
  PieChart, Pie, Cell,
  Tooltip, Legend, ResponsiveContainer,
  RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar,
  BarChart,
  CartesianGrid, XAxis, YAxis,
  LineChart, Line, Bar,
} from 'recharts';

type ChartProps = {
  data: any[];
}

export const CreatedApplicationsBarChart = memo(({ data }: ChartProps) => {
  return (
    <ResponsiveContainer height={245}>
      <BarChart
        data={data}
        margin={{
          right: 20,
          left: -10,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        {/* <Legend /> */}
        <Bar dataKey="value" fill="#38bdf8" />
      </BarChart>
    </ResponsiveContainer>
  )
})

export const CreatedApplicationsLineChart = memo(({ data }: ChartProps) => {
  return (
    <ResponsiveContainer height={245}>
      <LineChart
        data={data}
        margin={{
          right: 20,
          left: -10,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        {/* <Legend /> */}
        <Line type="monotone" dataKey="value" stroke="#8884d8" activeDot={{ r: 6 }} />
      </LineChart>
    </ResponsiveContainer>
  )
})

export const ServicesPieChart = memo(({ data }: ChartProps) => {
  const COLORS = chroma.scale(['#10b981', '#facc15', '#E11D48', '#0088FE']).mode('hsv').colors(data.length);

  return (
    <ResponsiveContainer height={245}>
      <PieChart>
        <Pie
          data={data}
          innerRadius={70}
          outerRadius={90}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
          nameKey="area"
          // label
          isAnimationActive
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Legend />
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  )
});

export const ServicesRadarChart = memo(({ data }: ChartProps) => {
  return (
    <ResponsiveContainer height={245}>
      <RadarChart outerRadius="80%" data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="area" />
        <PolarRadiusAxis />
        <Radar name="Services" dataKey="value" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
      </RadarChart>
    </ResponsiveContainer>
  )
});